import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { advisor } from '../../../../../models/advisor';
import { AdvisorsComponent } from '../../advisors.component';
import { WorkshopHours } from '../../../../../models/workshopHours';
import { APIAttentionSchedule } from 'src/services/api-services/api-service-attention-schedule';
import { ServiceAdvisorShedule } from 'src/services/api-services/api-interfaces/api-interface-service-advisor-schedule';
import { APIServiceAdvisorSchedule } from 'src/services/api-services/api-service-advisor-schedule';
import { finalize, forkJoin, Observable, tap } from 'rxjs';
import { APIBlockedAttentionSchedules } from 'src/services/api-services/api-blocked-attention-schedule';
import { Workshop } from '../../../../../models/workshop';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/services/helperService'

@Component({
    selector: 'app-configure-hours',
    templateUrl: './configure-hours-advisor.dialog.html',
    styleUrls: ['./configure-hours-advisor.dialog.sass'],
    standalone: false
})
export class ConfigureHoursDialogAdvisors {
  constructor(
    public dialogRef: MatDialogRef<AdvisorsComponent>,
    @Inject(MAT_DIALOG_DATA) public advisor: advisor,
    public AdvisorScheduleService: APIServiceAdvisorSchedule,
    public attetionDealerSchedulerservice: APIAttentionSchedule,
    public helperService: HelperService,
    private translate: TranslateService
  ) {}

  isCopyHoursOfMonday: boolean = false;
  Attenciondata: any = [];
  AttencionDealerdata: any = [];
  dropdownData: boolean = false;
  editWorkshopLoading: boolean = true;
  public StartHour: any = '10:00 A.M.';
  public hourFinal: any = '6:00 P.M.';
  public StartDate: any = '';
  public EndDate: any = '';
  TypeFuncionality: any;
  days: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  Mon: any = [];
  Dealer: any = [];
  timehours: string[] = [];
  v1: number = 24;
  v2: number = this.v1;



  dataInt: ServiceAdvisorShedule = {
    advisorScheduleId: 0,
    advisorId: 0,
    dayOfWeek: '',
    hourInitial: '',
    hourFinal: '',
    isActive: false,
    dayNumber: 0,
  };



  daysOfWeeks: any[] = [
    { day: 'Monday', daySet: 'Mon', arrayHours: [], isActiveWork: true, dayNumber:1,validateHours:false},
    { day: 'Tuesday', daySet: 'Tue', arrayHours: [], isActiveWork: true, dayNumber:2, validateHours:false },
    { day: 'Wednesday', daySet: 'Wed', arrayHours: [], isActiveWork: true, dayNumber:3, validateHours:false},
    { day: 'Thursday', daySet: 'Thu', arrayHours: [], isActiveWork: true, dayNumber:4, validateHours:false},
    { day: 'Friday', daySet: 'Fri', arrayHours: [], isActiveWork: true, dayNumber:5, validateHours:false},
    { day: 'Saturday', daySet: 'Sat', arrayHours: [], isActiveWork: true, dayNumber:6, validateHours:false},
    { day: 'Sunday', daySet: 'Sun', arrayHours: [], isActiveWork: true, dayNumber:0, validateHours:false},
  ];


  ngOnInit(): void {
    // this.getAttentionScheduleService()
    this.getAttentionScheduleService2();
    this.intervalHours();

  }
  // bring the hours of operation
  getAttentionScheduleService2() {
    this.AdvisorScheduleService?.getByAdvisor(this.advisor.advisorId)
      .pipe(
        tap((response) => {
          if (response !== null) {
            this.Attenciondata = response;

            for (let i = 0; i < this.days.length; i++) {
              this.Mon[i] = this.Attenciondata.filter(
                (data) => data.dayOfWeek === this.days[i]
              );
            }
          } else {
            for (let i = 0; i < this.days.length; i++) {
              this.Mon[i] = this.Attenciondata.filter(
                (data) => data.dayOfWeek === this.days[i]
              );
            }
          }
        }),
        finalize(() => this.getDealerAttentionScheduleService())
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  getDealerAttentionScheduleService() {
    this.attetionDealerSchedulerservice
      ?.getDealerBlockedSchedule(this.advisor.workshopId)
      .pipe(
        tap((response) => {
          if (!response.message) {
            this.AttencionDealerdata = response;

            for (let i = 0; i < this.days.length; i++) {
              this.Dealer[i] = this.AttencionDealerdata.filter(
                (data) => data.dayOfWeek === this.days[i]
              );
            }
          }
        }),
        finalize(() => this.DataInt())
      ).subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }

          const translateTxtNotMatch = this.translate.instant("notMatchFound")
          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =translateTxtNotMatch
          setTimeout(() => {
            this.helperService.showAlert =false
          }, 7000)
        }
      });
  }


  intervalHours() : void {
    const openTime: Date = new Date(0,0,0,5,0,0);
    const closeTime: Date = new Date(0,0,0,19,45,0);
    const stepTime: number = 15 * 60 * 1000;

    for(let hour = openTime.getTime(); hour <= closeTime.getTime(); hour += stepTime) {

      const timeString: string = new Date(hour).toLocaleTimeString("es-CO" , {  hour: 'numeric', minute: '2-digit',hour12: true })
      this.timehours.push(timeString.toUpperCase());

    }
  }

  ValidationOfCorrectHoursAdvisor(index){

    let hour = moment(this.daysOfWeeks[index].startTime, 'h:mm A').format('HH:mm:ss');
    let split = hour.split(':');
    let hour_inicial_validacion = Number(split[0] + split[1]);
    hour = moment(this.daysOfWeeks[index].endTime, 'h:mm A').format('HH:mm:ss')
    split = hour.split(':');
    let hour_final_validacion = Number(split[0] + split[1]);

    this.daysOfWeeks[index].validateHours=false
    if (hour_inicial_validacion > hour_final_validacion) {
      //if any filter is filled the button will be enabled
      this.daysOfWeeks[index ].validateHours=true
    }

  }

  issaveDisabled(): boolean {
    // function to enable clear button conditionally
    let isDisabled = true;
    if (
      this.daysOfWeeks.filter((daysOfWeeks) => daysOfWeeks.validateHours === true).length === 0
    ) {
      //if any filter is filled the button will be enabled
      isDisabled = false;
    }
    return isDisabled;
  }

  //trasformation data
  DataInt() {
    this.dropdownData = true;
    this.daysOfWeeks.map((item) => item.day = this.translate.instant(item.day));

    if (this.Mon[0].map((data) => data.isActive)[0] === undefined) {
      this.TypeFuncionality = 'New';
    } else {
      this.TypeFuncionality = 'Old';
    }

    for (let i = 0; i < this.daysOfWeeks.length; i++) {
      this.daysOfWeeks[i].arrayHours = [...this.timehours];

      if (this.Dealer[i].length === 0) {
        this.daysOfWeeks[i].arrayHours = [];
      } else {
        let start = this.Dealer[i]
          .map((data) => data.hourInitial)[0]
          .split(':');
        start = this.militaryTimeToNormalTime(Number(start[0]), start[1]);
        let end = this.Dealer[i].map((data) => data.hourFinal)[0].split(':');
        end = this.militaryTimeToNormalTime(Number(end[0]), end[1]);
        this.daysOfWeeks[i].arrayHours.splice(
          0,
          this.daysOfWeeks[i].arrayHours.indexOf(start)
        );
        this.daysOfWeeks[i].arrayHours.splice(
          this.daysOfWeeks[i].arrayHours.indexOf(end) + 1,
          this.daysOfWeeks[i].arrayHours.length
        );
      }
      if (
        this.Dealer[i].map((data) => data.isActive)[0] === false ||
        this.Dealer[i].map((data) => data.isActive)[0] === undefined
      ) {
        this.daysOfWeeks[i].isActiveWork = true;
        this.daysOfWeeks[i].isActive = false;
      } else {
        this.daysOfWeeks[i].isActiveWork = false;
        this.daysOfWeeks[i].isActive = this.Mon[i].map(
          (data) => data.isActive
        )[0];
      }

      this.daysOfWeeks[i].startTime = this.Mon[i]
        .map((data) => data.hourInitial)
        .toString();
      this.daysOfWeeks[i].endTime = this.Mon[i]
        .map((data) => data.hourFinal)
        .toString();

      let hour = this.daysOfWeeks[i].startTime.split(':');
      this.daysOfWeeks[i].startTime = this.militaryTimeToNormalTime(
        Number(hour[0]),
        hour[1]
      );
      hour = this.daysOfWeeks[i].endTime.split(':');
      this.daysOfWeeks[i].endTime = this.militaryTimeToNormalTime(
        Number(hour[0]),
        hour[1]
      );
    }
  }

  // change to standard time
   militaryTimeToNormalTime(Hor: number, Hor2: string) {
  let hora: any = Hor;
  let string = '';

  if (Hor > 12) {
    hora = hora - 12;
    string = hora + ':' + Hor2 + ' P. M.';
  } else if (Hor === 0) {
    string = '';
  } else if (Hor === 12) {
    string = hora + ':' + Hor2 + ' P. M.';
  } else {
    string = Hor + ':' + Hor2 + ' A. M.';
  }

  return string.trim();
}

  convertTime12To24(time) {
  let hours = Number(time.match(/^(\d+)/)[1]);
  let minutes = Number(time.match(/:(\d+)/)[1]);
  let AMPM = time.match(/\s(.*)$/)[1].trim();
 
  if (AMPM === 'P. M.' && hours < 12) {
    hours += 12;
  }
 
  if (AMPM === 'A. M.' && hours === 12) {
    hours = 0;
  }
 
  return (
    hours.toString().padStart(2, '0') +
    ':' +
    minutes.toString().padStart(2, '0')
  );
}


  onCancel(): void {
    this.dialogRef.close();
  }

  onSave() {
    if (this.TypeFuncionality === 'Old') {
      for (let i = 0; i < 7; i++) {
        this.dataInt.advisorId = this.Mon[i].map((data) => data.advisorId)[0];
        this.dataInt.advisorScheduleId = this.Mon[i].map(
          (data) => data.advisorScheduleId
        )[0];
        this.dataInt.dayOfWeek = this.daysOfWeeks[i].daySet;
        this.dataInt.hourInitial = this.daysOfWeeks[i].startTime;
        this.dataInt.hourFinal = this.daysOfWeeks[i].endTime;
        this.dataInt.isActive = this.daysOfWeeks[i].isActive;
        this.dataInt.dayNumber = this.daysOfWeeks[i].dayNumber;

        if (this.isCopyHoursOfMonday === true) {

            this.dataInt.hourInitial = '';
            this.dataInt.hourFinal = '';

            let hour = moment(this.daysOfWeeks[0].startTime, 'h:mm A').format('HH:mm:ss');
            let split = hour.split(':');
            let hour_inicial_validacion = Number(split[0] + split[1]);

            hour = moment(this.daysOfWeeks[0].endTime, 'h:mm A').format('HH:mm:ss')
            split = hour.split(':');
            let hour_final_validacion = Number(split[0] + split[1]);

            hour = moment(this.daysOfWeeks[i].arrayHours[0], 'h:mm A').format('HH:mm:ss');
             split = hour.split(':');
            let hour_inicial_validacion_dealer = Number(split[0] + split[1]);

            hour = moment(this.daysOfWeeks[i].arrayHours[this.daysOfWeeks[i].arrayHours.length-1], 'h:mm A').format('HH:mm:ss')
            split = hour.split(':');
            let hour_final_validacion_dealer = Number(split[0] + split[1]);

            if (hour_inicial_validacion >= hour_inicial_validacion_dealer && hour_final_validacion<= hour_final_validacion_dealer) {
              this.dataInt.hourInitial = this.convertTime12To24(this.daysOfWeeks[0].startTime) + ':00';
              this.dataInt.hourFinal = this.convertTime12To24(this.daysOfWeeks[0].endTime) + ':00';
            }

        } else {
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== '' &&
            this.dataInt.hourInitial !== undefined &&
            this.dataInt.hourFinal !== undefined
          ) {
            this.dataInt.hourInitial =
              this.convertTime12To24(this.daysOfWeeks[i].startTime) + ':00';
            this.dataInt.hourFinal =
              this.convertTime12To24(this.daysOfWeeks[i].endTime) + ':00';
          }
        }

        if (this.Mon[i].map((data) => data.advisorId)[0] === undefined) {
          this.dataInt.advisorId = this.advisor.advisorId;
          this.dataInt.advisorScheduleId = 0;
          this.dataInt.dayOfWeek = this.daysOfWeeks[i].daySet;
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== '' &&
            this.dataInt.hourInitial !== undefined &&
            this.dataInt.hourFinal !== undefined
          ) {

            this.AdvisorScheduleService?.post(this.dataInt).subscribe({
              error: () => {
                const translateTxtNotMatch = this.translate.instant("notMatchFound")
                this.helperService.showAlert =true
                this.helperService.typeAlert ="error"
                this.helperService.messageAlert =translateTxtNotMatch
                setTimeout(() => {
                  this.helperService.showAlert =false
                }, 7000)
              }
            });
          }
        } else {
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== '' &&
            this.dataInt.hourInitial !== undefined &&
            this.dataInt.hourFinal !== undefined
          ) {

          this.AdvisorScheduleService?.put(this.dataInt).subscribe({
            error: () => {
              const translateTxtNotMatch = this.translate.instant("notMatchFound")
              this.helperService.showAlert =true
              this.helperService.typeAlert ="error"
              this.helperService.messageAlert =translateTxtNotMatch
              setTimeout(() => {
                this.helperService.showAlert =false
              }, 7000)
            }
          });
        }
        }
      }
    } else {
      for (let i = 0; i < 7; i++) {
        this.dataInt.advisorId = this.advisor.advisorId;
        this.dataInt.advisorScheduleId = 0;
        this.dataInt.dayOfWeek = this.daysOfWeeks[i].daySet;
        this.dataInt.hourInitial = this.daysOfWeeks[i].startTime;
        this.dataInt.hourFinal = this.daysOfWeeks[i].endTime;
        this.dataInt.isActive = this.daysOfWeeks[i].isActive;
        this.dataInt.dayNumber = this.daysOfWeeks[i].dayNumber;
        if (this.isCopyHoursOfMonday === true) {
          this.dataInt.hourInitial =
            this.convertTime12To24(this.daysOfWeeks[0].startTime) + ':00';
          this.dataInt.hourFinal =
            this.convertTime12To24(this.daysOfWeeks[0].endTime) + ':00';
        } else {
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== ''
          ) {
            this.dataInt.hourInitial =
              this.convertTime12To24(this.daysOfWeeks[i].startTime) + ':00';
            this.dataInt.hourFinal =
              this.convertTime12To24(this.daysOfWeeks[i].endTime) + ':00';
          }
        }
        if (
          this.dataInt.hourInitial !== '' &&
          this.dataInt.hourFinal !== '' &&
          this.dataInt.hourInitial !== undefined &&
          this.dataInt.hourFinal !== undefined
        ) {
          this.AdvisorScheduleService?.post(this.dataInt).subscribe();
        }
      }
    }
    const translateText = this.translate.instant(
      'ToastAdvisorConfigure',
      {
        fullName:this.advisor.advisorName
      }
    )
    this.helperService.showAlert =true
    this.helperService.typeAlert ="success"
    this.helperService.messageAlert =translateText
    setTimeout(() => {
      this.helperService.showAlert =false
    }, 7000)
    this.dialogRef.close('NewData');
  }
}